import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Tabs from "./Tabs";
import TabPane from "./TabPane";
import MyOrderPane from "./MyOrderPane";
export class MyOrder extends Component {
  state = {
    defaultActiveKey: 0,
  }
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  componentWillMount() {
    let { pathname } = this.props.history.location;
    pathname = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
    this.setState({
      defaultActiveKey: parseInt(pathname, 10),
    })
  }
  updateRouter(activeKey) {
    this.props.history.replace(`/center/myOrder/${activeKey}`);
  }
  render() {
    const { defaultActiveKey } = this.state;
    return (
      <div className="center-my-order">
        <div className="tabs">
          <Tabs
            {...this.props}
            defaultActiveKey={defaultActiveKey}
            onTabsChange={(activeKey) => {
              this.setState({
                defaultActiveKey: activeKey
              });
              this.updateRouter(activeKey);
            }}
            tabs={[{ Name: "全部" }, { Name: "待支付" }, { Name: "已开通" }, { Name: "已取消" }]}
          />
        </div>
        <TabPane {...this.props} defaultActiveKey={defaultActiveKey}>
          <MyOrderPane {...this.props} PayStatus={-1} />
          <MyOrderPane {...this.props} PayStatus={0} />
          <MyOrderPane {...this.props} PayStatus={1} />
          <MyOrderPane {...this.props} PayStatus={2} />
        </TabPane>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MyOrder);



// WEBPACK FOOTER //
// ./src/features/center/MyOrder.js